import React, { useState } from "react";
import styles from "./Prediction.module.css";
import vsIcon from "../../assests/vsIcon.svg";
import predictlogo from "../../assests/PredictWinners.png";
import prediction from "../../assests/Prediction.png";
import trophy from "../../assests/trophy.png";

export default function Prediction({ question, onAnswerSelect, number }) {
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const matchDate = new Date(question?.matchDate);
  const formattedMatchDate = `${matchDate.toLocaleString("default", {
    month: "long",
  })} ${matchDate.getUTCDate()} ${matchDate.getUTCFullYear()} , ${matchDate.toLocaleTimeString()}`;
  const matchFinished = matchDate < new Date();
  const handleOptionSelect = (value) => {
    if (question?.status !== "CLOSED" && !matchFinished) {
      onAnswerSelect(number, question?.id, value);
      setSelectedAnswer(value);
    }
  };

  return (
    <div
      className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414]"
      key={number}
    >
      <div className="flex items-center gap-[6px] pb-[16px] border-b-[1px] border-[#363636]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M8.66137 2.649C8.69235 2.58558 8.74052 2.53214 8.80039 2.49476C8.86026 2.45738 8.92942 2.43756 9 2.43756C9.07058 2.43756 9.13974 2.45738 9.19961 2.49476C9.25947 2.53214 9.30764 2.58558 9.33862 2.649L11.1319 6.3C11.187 6.41175 11.2931 6.48938 11.4165 6.50738L15.4264 7.09275C15.7361 7.13812 15.8595 7.52062 15.6356 7.74L12.7339 10.5821C12.6899 10.625 12.657 10.678 12.638 10.7365C12.6191 10.795 12.6147 10.8572 12.6251 10.9178L13.3102 14.9303C13.3631 15.2404 13.0395 15.477 12.7624 15.3307L9.17587 13.4359C9.12171 13.4071 9.06132 13.3921 9 13.3921C8.93867 13.3921 8.87828 13.4071 8.82412 13.4359L5.23762 15.3307C4.9605 15.477 4.63687 15.2407 4.68975 14.9306L5.3745 10.9181C5.38503 10.8575 5.38063 10.7952 5.36168 10.7367C5.34273 10.6781 5.30981 10.6251 5.26575 10.5821L2.36475 7.74C2.1405 7.52062 2.26425 7.13812 2.574 7.09275L6.58425 6.50775C6.70725 6.48938 6.81337 6.41175 6.8685 6.3L8.66137 2.649Z"
            fill="#FFE100"
          />
        </svg>
        {matchDate != "Invalid Date" && (
          <p className="text-small-medium ">Match Day: {formattedMatchDate}</p>
        )}{" "}
      </div>

      <div className=" w-full">
        <div className="my-[18px] flex w-[100%] gap-[17px] justify-evenly items-center">
          <div
            className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
              selectedAnswer == "team1" && "border-[1px] border-[#FFA82833]"
            }`}
            onClick={() => handleOptionSelect("team1")}
          >
            {selectedAnswer == "team1" && (
              <img src={trophy} className="absolute top-[-10px] mx-auto" />
            )}
            <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
              <img src={question?.team1?.logo} alt="" />
            </div>
            <p className="text-white mt-[12px] text-center text-small-medium">
              {question?.team1?.name}
            </p>
          </div>
          <img src={vsIcon} className="" />
          <div
            className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
              selectedAnswer == "team2" && "border-[1px] border-[#FFA82833]"
            }`}
            onClick={() => handleOptionSelect("team2")}
          >
            {selectedAnswer == "team2" && (
              <img src={trophy} className="absolute top-[-10px] mx-auto" />
            )}

            <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
              <img src={question?.team2?.logo} alt="" />
            </div>
            <p className="text-white mt-[12px] text-center text-small-medium">
              {" "}
              {question?.team2.name}
            </p>
          </div>
        </div>
        <div className="flex w-full items-center gap-[16px] pt-[16px] border-t-[1px] border-[#363636]">
          <img
            src={selectedAnswer ? prediction : predictlogo}
            className="h-[12px]"
          />
          {question?.status == "CLOSED" || matchFinished ? (
            <p className={styles.select}>Closed</p>
          ) : (
            <p className="text-small-medium">
              {question &&
                question[selectedAnswer] &&
                question[selectedAnswer].name}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
